'use strict';
angular.module('viewTracesModule', []).controller('viewTracesCtrl', ['$scope', '$sce', '$stateParams', '$q', '$element', '$compile', 'trsHttpService', 'newMediaService', 'previewService',
    function ($scope, $sce, $stateParams, $q, $element, $compile, trsHttpService, newMediaService, previewService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化参数与状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                listOpen: 1,
                params: {
                    serviceid: 'mlf_website',
                    methodname: 'getNewsDoc',
                    MetaDataId: $stateParams.docversionid,
                    MediaType: $stateParams.mediatype
                },
                previewBigFace: {}
            };
            $scope.item = '';
            $scope.data = {
                keywords: [],
                isShowKeywords: {
                    1: true,
                    2: true,
                    4: true
                }
            };
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData($scope.status.params).then(function (data) {
                $scope.data.item = data;
                $scope.data.item.ABSTRACT = angular.isDefined($scope.data.item.ABSTRACT) ? $scope.data.item.ABSTRACT.replace(/\n/g, '<br/>') : '';
                $scope.data.item.CONTENT = $sce.trustAsHtml($scope.data.item.CONTENT);
                $scope.data.htmlContent = $sce.trustAsHtml(data.HTMLCONTENT);
                loadDirective();
                bigFace();
            });
        }

        $scope.bigFace = function() {
            bigFace();
        };

        /**
         * [bigFace description] 查看痕迹
         * @return {[type]} [description]
         */
        function bigFace() {
            $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        }

        /**
         * [requestData description]数据请求
         * @param  {[obj]} params [description]请求参数
         * @return {[type]}        [description]
         */
        function requestData(params) {
            var deferrd = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                if (data.KEYWORDS) {
                    $scope.data.keywords = data.KEYWORDS.split(';');
                }
                deferrd.resolve(data);
            });
            return deferrd.promise;
        }

        /**
         * [loadDirective description]动态加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var htmlContent = '<div adjustsize class="padding20" trs-play-audio-video  ng-bind-html="data.htmlContent">';
            var videoContent = '<div trs-upload-for-xj-video-draft list="data.item" preview="true"></div>';
            newMediaService.previewLoadDirective($element, $compile, $scope, htmlContent, videoContent);
        }
    }
]);
